// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__38Zh0","error":"Textarea_error__1gpnD","readonly":"Textarea_readonly__295-R","disabled":"Textarea_disabled__2IUx-"};